module.exports = __webpack_public_path__ + "img/full3-min.aa660590.png";